import { useState, useEffect } from "react";
import axios from "axios";
import "./AfterVisit.css";
import { EVENT_DETAILS_BY_AFTER_VISIT } from "../ApiDetails";

const AfterVisit = () => {
  const storedData = localStorage.getItem("reportsFilter");
  const parsedData = JSON.parse(storedData);

  const [eventDetails, setEventDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (parsedData) {
      const {
        selectedCountry,
        selectedEventType,
        selectedEventFormat,
        selectedAssociate,
        startDate,
        endDate,
      } = parsedData;

      const apiUrl = `${EVENT_DETAILS_BY_AFTER_VISIT}?country=${encodeURIComponent(
        selectedCountry
      )}&type=${encodeURIComponent(
        selectedEventType
      )}&formate=${encodeURIComponent(
        selectedEventFormat
      )}&associate=${encodeURIComponent(
        selectedAssociate
      )}&startdate=${encodeURIComponent(
        startDate
      )}&enddate=${encodeURIComponent(endDate)}`;

      axios
        .get(apiUrl, { headers: { accept: "text/plain" } })
        .then((response) => {
          setEventDetails(response.data);
        })
        .catch(() => {
          setError("Failed to fetch data. Please try again.");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [storedData]);
  const totalAttendees = eventDetails.reduce(
    (total, item) => total + item.associateCount,
    0
  );

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="after-visit-container">
      {eventDetails.length === 0 ? (
        <p>No event details found for the selected filters.</p>
      ) : (
        <ul className="afterEventList">
          <li className="totalAttendees">
            <span>Total people attendees</span>
            <strong>{totalAttendees}</strong>
          </li>
          {eventDetails.map((event, index) => (
            <li key={index} className="afterEventItem">
              <span>{event.associatesCategory}</span>
              <strong>{event.associateCount}</strong>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AfterVisit;
